module.exports = __webpack_public_path__ + "56ab0eb86d2c1aec4d39bf764ac3d118.svg";